class AddressService {
    getValFromRecords(key, data) {
        if (!data) {
            return;
        }
        const records = data.filter(r => { var _a; return ((_a = r.types.find(r => r.includes(key))) === null || _a === void 0 ? void 0 : _a.length) > 0; });
        if (records.length === 0) {
            return null;
        }
        const record = records.slice(1).reduce((res, r) => {
            const a = res.types.filter(r => r.includes(key)).join('');
            const b = r.types.filter(r => r.includes(key)).join('');
            if (a >= b && /\w/.test(r.short_name)) {
                res = r;
            }
            return res;
        }, records[0]);
        return record === null || record === void 0 ? void 0 : record.short_name;
    }
    resolveCity(list) {
        const result = list.reduce((res, row) => {
            res = [...res, ...row.address_components];
            return res;
        }, []);
        const city = this.getValFromRecords('locality', result);
        return city;
    }
    parseAddress(list) {
        const result = list.reduce((res, row) => {
            res = [...res, ...row.address_components];
            return res;
        }, []);
        const address = {
            country: this.getValFromRecords('country', result),
            region: this.getValFromRecords('administrative_area', result),
            city: this.getValFromRecords('sublocality', result) || this.getValFromRecords('locality', result),
            district: this.getValFromRecords('neighborhood', result),
            street: this.getValFromRecords('route', result) ||
                this.getValFromRecords('route', result),
            building: this.getValFromRecords('street_number', result) ||
                this.getValFromRecords('street_number', result),
            postalCode: this.getValFromRecords('postal_code', result),
            postalCodeSuffix: this.getValFromRecords('postal_code_suffix', result),
        };
        Object.keys(address).forEach(key => { var _a; return !((_a = address[key]) === null || _a === void 0 ? void 0 : _a.trim()) ? delete address[key] : {}; });
        return address;
    }
    getStringWithPrefix(prefix, str) {
        if (!!(str === null || str === void 0 ? void 0 : str.toString().trim())) {
            return `${prefix}: ${str}`;
        }
    }
    display(address) {
        if (address.address) {
            return address.address;
        }
        return [
            this.getStringWithPrefix('Flat', address.apartment),
            this.getStringWithPrefix('Office.', address.office),
            this.getStringWithPrefix('Building', address.building),
            this.getStringWithPrefix('Street', address.street),
            this.getStringWithPrefix('District', address.district),
            address.city,
            address.region,
            address.country
        ].filter(Boolean).join(', ');
    }
}
export default new AddressService();
export const AddressServiceClass = AddressService;
